<template>
    <div>
      <textarea class="am-textarea" v-bind:value="value" :id="id"></textarea>
    </div>
</template>

<script>
export default {
  data: function () {
    const uniqueId = this.prefix + '_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

    return {
      id: uniqueId,
      editor: null
    }
  },
  name: 'RichTextEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: 'rte'
    }
  },

  methods: {
    initializeTinyMCE () {
      const self = this
      // let baseUrl = tinyMCE.baseURL;
      // tinyMCE.baseURL = baseUrl.replace('js', '');
      tinyMCE.init({
        setup: function (editor) {
          editor.on('change', function (e) {
            self.$emit('input', editor.getContent())
          })
        },
        selector: '#' + this.id,
        theme: 'silver',
        plugins: ['textcolor fullscreen pagebreak table code image paste link lists'],
        menubar: false,
        toolbar1: 'undo redo | bold italic underline strikethrough |  alignleft aligncenter alignright alignjustify',
        toolbar2: 'bullist numlist outdent indent | link image | code fullscreen',
        valid_children: '+body[style]',
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,
        object_resizing: false,
        paste_data_images: true,
        tools: 'tags',
        browser_spellcheck: true,
        content_style: 'body {height: 461px}'
      })
      // tinyMCE.baseURL = baseUrl;
      this.editor = tinymce.get(this.id)
    }
  },

  mounted () {
    let self = this
    setTimeout(function () {
      self.initializeTinyMCE()
    }, 0)
  },

  watch: {
    'value': function (newValue, oldValue) {
      if (oldValue === newValue || this.editor.getContent() === newValue) {
        return
      }
      this.editor.setContent(newValue)
    }
  }
}

</script>

<style scoped>
  .am-textarea {
    background: white;
    margin-top: 5px;
    width: 500px;
    height: 250px;
    max-width: 500px;
  }
</style>
